import React from 'react';
import '../../../assets/css/Buyer/General/herosections.css';

/**
 * PageHero — Reusable Hero Section Component
 * Estate Experts | Brand Kit Applied
 *
 * Props:
 * @param {string}  title        - Main large heading
 * @param {string}  subtitle     - Smaller text below title
 * @param {string}  [label]      - Small uppercase badge above title (optional)
 * @param {string}  [image]      - Background image URL (optional, falls back to default)
 * @param {string}  [align]      - Text alignment: 'center' | 'left' | 'right' (default: 'center')
 * @param {string}  [size]       - Hero height: 'sm' | 'md' | 'lg' (default: 'md')
 * @param {node}    [children]   - Optional extra content (breadcrumb, button, etc.)
 */

const DEFAULT_IMAGE =
  'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920';

const HeroSection = ({
  title,
  subtitle,
  label,
  image = DEFAULT_IMAGE,
  align = 'center',
  size = 'md',
  children,
}) => {
  return (
    <section
      className={`ph-hero ph-hero--${size} ph-hero--${align}`}
      style={{ backgroundImage: `url(${image})` }}
      aria-label={`${title} hero section`}
    >
      {/* Layered overlays for depth */}
      <div className="ph-overlay ph-overlay--base" />
      <div className="ph-overlay ph-overlay--gradient" />
      <div className="ph-overlay ph-overlay--grain" />

      {/* Decorative lines */}
      <div className="ph-deco-line ph-deco-line--left" />
      <div className="ph-deco-line ph-deco-line--right" />

      {/* Content */}
      <div className="ph-content-wrap">
        {label && (
          <span className="ph-label">
            <span className="ph-label-dash" />
            {label}
            <span className="ph-label-dash" />
          </span>
        )}

        <h1 className="ph-title">
          {title}
        </h1>

        {subtitle && (
          <p className="ph-subtitle">{subtitle}</p>
        )}

        {children && (
          <div className="ph-children">
            {children}
          </div>
        )}
      </div>

      {/* Bottom fade into page */}
      <div className="ph-bottom-fade" />
    </section>
  );
};

export default HeroSection;